import type { IconProps } from '../types/IconProps.ts';
export const ShoppingCartPlus: IconProps = {
    name: 'ShoppingCartPlus',
    children: [
        `<path d="m4 2 1 5 1.65 7.43A2 2 0 0 0 8.6 16h9.8a2 2 0 0 0 1.95-1.57l1.1-5M5 7h7.25M2 2h2M9 22a1 1 0 1 0 0-2 1 1 0 0 0 0 2M18 22a1 1 0 1 0 0-2 1 1 0 0 0 0 2M18 4v4M16 6h4" />`,
    ]
};